module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 16
// module chunks = 0 1